import { CircleLoader } from "react-spinners";

import { combineClassNames } from "@utils/appUtils";

import WPHeading from "@components/WPHeading";

import LoaderStyled from "@common/styles/LoaderStyled";
const Loader = ({ className }) => (
  <>
    <LoaderStyled className={combineClassNames("sweet-loading", className)} data-test-id='wp-loader'>
      <div>
        <CircleLoader color={"#007672"} loading={true} />
        <WPHeading text='WAVE PRO' className='my-2' />
      </div>
    </LoaderStyled>
  </>
);

export default Loader;
